import { isElectron } from '@web-chat-core/ui-kit/helpers/electron';

class RaiseHandSound {
    private sound = new Audio(isElectron ? './hand-raised-rington.mp3' : '/hand-raised-rington.mp3');

    public loadSound() {
        this.sound.load();
    }

    public playSound() {
        if (this.checkIsPlaying()) {
            this.stopSound();
        }

        this.sound.play();
    }

    public stopSound() {
        this.sound.pause();
        this.sound.currentTime = 0;
    }

    public checkIsPlaying() {
        return (
            // There is no simple way to check is audio playing
            this.sound &&
            this.sound.currentTime > 0 &&
            !this.sound.paused &&
            !this.sound.ended &&
            this.sound.readyState > 2
        );
    }
}

const raiseHandSound = new RaiseHandSound();
export { raiseHandSound };
